import * as types from './actionTypes'

export const fetchEntitiesSuccess = (data) => ({
    type: types.ENTITIES_FETCH_SUCCESS,
    data
})

export const fetchEntitiesFailed = () => ({
    type: types.ENTITIES_FETCH_FAILED
})

export const fetchRenameEntity = (name, entity) => ({
    type: types.RENAME_ENTITY_FETCH,
    name,
    entity
})

export const fetchRenameEntitySuccess = () => ({
    type: types.RENAME_ENTITY_SUCCESS
})

export const fetchRenameEntityFailed = () => ({
    type: types.RENAME_ENTITY_FAILED
})

export const fetchRenameCol = (name, col) => ({
    type: types.RENAME_COL_FETCH,
    name,
    col
})

export const fetchRenameColSuccess = () => ({
    type: types.RENAME_COL_SUCCESS
})

export const fetchRenameColFailed = () => ({
    type: types.RENAME_COL_FAILED
})

export const fetchDeleteCol = (col) => ({
    type: types.DELETE_COL_FETCH,
    col
})

export const fetchDeleteColSuccess = () => ({
    type: types.DELETE_COL_SUCCESS
})

export const fetchDeleteColFailed = () => ({
    type: types.DELETE_COL_FAILED
})

export const fetchAddCol = (entity) => ({
    type: types.ADD_COL_FETCH,
    entity
})

export const fetchAddColSuccess = (col) => ({
    type: types.ADD_COL_SUCCESS,
    col
})

export const fetchAddColFailed = () => ({
    type: types.ADD_COL_FAILED
})

export const resetCreatedCol = () => ({
    type: types.RESET_CREATED_COL
})

export const changeTypeToBasic = (field, fieldType) => ({
    type: types.CHANGE_TYPE_TO_BASIC,
    field,
    fieldType
})

export const changeTypeSuccess = () => ({
    type: types.CHANGE_TYPE_SUCCESS
})

export const changeTypeFailed = () => ({
    type: types.CHANGE_TYPE_FAILED
})

export const changeTypeToComplex = (field, config, format) => ({
    type: types.CHANGE_TYPE_TO_COMPLEX,
    field,
    config,
    format
})

export const deleteEntity = (id) => ({
    type: types.ENTITY_DELETE,
    id
})

export const deleteEntitySuccess = (entity) => ({
    type: types.ENTITY_DELETE_SUCCESS,
    entity
})

export const deleteEntityFailed = () => ({
    type: types.ENTITY_DELETE_FAILED
})

export const setDefaultValue = (field, value) => ({
    type: types.SET_DEFAULT_VALUE,
    field,
    value
})

export const setDefaultValueSuccess = () => ({
    type: types.SET_DEFAULT_VALUE_SUCCESS
})

export const setDefaultValueFailed = () => ({
    type: types.SET_DEFAULT_VALUE_FAILED
})
